import { useState, useCallback } from 'react';
import { useAuthState } from 'state/useAuthState';
import { MapMouseEvent } from 'shared/map-exports';
import { useReleaseFlag } from './useReleaseFlags';

export type ContextMenuCoordinatesType = {
  mouseX: number;
  mouseY: number;
  lat: number;
  lng: number;
};

type UseCtxMenuType = {
  contextMenuCoordinates: ContextMenuCoordinatesType | null;
  ctxMenuClose: () => void;
  openContextMenu: (event: MapMouseEvent) => void;
};

export const useContextMenu = (): UseCtxMenuType => {
  const { showMembershipProFeatures } = useAuthState();
  const pinImprovements = useReleaseFlag('pin_drop_improvements');
  const [contextMenuCoordinates, setContextMenuCoordinates] =
    useState<ContextMenuCoordinatesType | null>(null);

  const ctxMenuClose = (): void => {
    setContextMenuCoordinates(null);
  };

  const openContextMenu = useCallback(
    (event: MapMouseEvent): void => {
      event.preventDefault();
      if (pinImprovements || showMembershipProFeatures) {
        setContextMenuCoordinates(
          contextMenuCoordinates === null
            ? {
                mouseX: event.originalEvent.clientX + 2,
                mouseY: event.originalEvent.clientY - 6,
                lat: event.lngLat.lat,
                lng: event.lngLat.lng,
              }
            : null,
        );
      }
    },
    [showMembershipProFeatures, contextMenuCoordinates, pinImprovements],
  );

  return {
    ctxMenuClose,
    contextMenuCoordinates,
    openContextMenu,
  };
};
